import React from "react";
import { workAtDark, tryDark } from "../../Markup";
const careersPageData = [
  {
    type: "Center",
    class: "white-background wide short",
    title: { text: "Work at Dark", class: "large-title medium-purple" },
    paragraphClass: "center-paragraph",
    paragraph: [
      <p className="small-title dark-purple-text justify-text">
        At Dark, we get to work on a big problem: it’s still too hard to code.
      </p>,
      <p className="small-title dark-purple-text justify-text">
        We like our mission, but that isn’t the only thing that matters in a
        job. We want to make this a great place to work, and that means we care
        a lot about our core values, and we provide benefits that matter, like
        parental leave and{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          className={"light-purple"}
          href="https://medium.com/darklang/why-dark-covers-100-of-employee-and-dependent-healthcare-faa0832ef23c"
        >
          full health care coverage for you and your dependents
        </a>
        .
      </p>,
      <p className="small-title dark-purple-text justify-text">
        We're hiring in person in San Francisco, and remotely in North and South
        America (specifically, in timezones within 3 hours of US Central Time).
        Our office is wheelchair accessible.
      </p>
    ]
  },
  {
    type: "TitleThreeColumn",
    class: "white-background narrow-cols lrg-space-below",
    title: null,
    columns: [
      {
        icon: {
          src: "dark-logo",
          url: "/about#team"
        },
        class: "",
        link: {
          class: "small-title MankSans-Medium light-purple",
          text: "Our Team",
          url: "/about#team"
        }
      },
      {
        icon: {
          class: "icon-size",
          src: "heart",
          url: "/about#values"
        },
        class: "",
        link: {
          class: "small-title MankSans-Medium light-purple",
          text: "Our Values",
          url: "/about#values"
        }
      },
      {
        icon: {
          class: "icon-size",
          src: "plus-square",
          url: "/careers/benefits"
        },
        class: "",
        link: {
          class: "small-title MankSans-Medium light-purple",
          text: "Our Benefits",
          url: "/careers/benefits"
        }
      },
      {
        icon: {
          class: "icon-size",
          src: "desktop",
          url: "/careers/interviewing"
        },
        class: "",
        link: {
          class: "small-title MankSans-Medium light-purple",
          text: "Interviewing",
          url: "/careers/interviewing"
        }
      }
    ]
  },

  {
    type: "Center",
    class: "dark-purple-background wide",
    title: { text: "Job Openings", class: "title large-title white-text" },
    paragraphClass: "center-paragraph white-text paragraph-text",
    paragraph: [
      <p className="justify-text">
        We’ve built out the first version of the Dark language, editor, and
        infrastructure, and we’re excited to keep going.
      </p>,
      <p className="justify-text">
        That means building more, engaging with our developer community, and
        supporting our team. At Dark, we don’t fit into narrow descriptions, so
        we don’t expect you to either. We hope one (or two or more!) of these
        titles and descriptions might resonate with you. We can work out the
        details when we talk.{" "}
        <a className="blue-purple" href="#apply">
          Apply now.
        </a>
      </p>
    ]
  },
  {
    type: "LeftAlignTwoColumn",
    class: "dark-purple-background purple-sideline",
    columns: [
      {
        title: {
          class: "white-text large-title",
          text: "Software Engineer"
        },
        paragraph: {
          class: "white-text paragraph-text MankSans-Medium",
          text:
            "We want to democratize coding by making it 100x easier to build software, so the next billion people can code. First, we're going to make it so developers can build a complete scalable app in an afternoon. That means removing all the annoying things about building software, and creating an amazing development experience."
        },
        link: {
          class: "blue-purple paragraph-text MankSans-Medium",
          text: "Learn more",
          url: "/careers/software-engineer"
        }
      }
    ]
  },
  {
    type: "Center",
    class: "white-background short wide",
    id: "apply",
    title: { text: "How to Apply", class: "title large-title black-text" },
    paragraphClass: "center-paragraph black-text paragraph-text",
    paragraph: [
      <p className="small-title justify-text">
        You can reach us at{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="light-purple"
          href="mailto:careers@darklang.com"
        >
          careers@darklang.com
        </a>
        .
      </p>,
      <p className="small-title justify-text">
        Please include your resume or LinkedIn. Apart from that, we want to get
        to know you. Give us some more context in a way that makes sense for you
        and the job you'd like to do. It could be a qualitative description of
        how you've thought about your career, why you love a specific
        programming language, or how you'd like to contribute at Dark.
      </p>
    ]
  },

  {
    type: "TwoColumn",
    class: "short lavender-background taller-col",
    columns: [
      {
        type: "map"
      },
      {
        type: "text",
        rows: [
          {
            class: "purple",
            title: {
              class: "purple large-title",
              text: "Location"
            },
            paragraph: {
              class: "small-title",
              text:
                "We hire remote, but our office is in Duboce Triangle in San Francisco \n (Near Mission, Castro and Lower Haight)"
            }
          },
          {
            class: "",
            title: {
              class: "purple large-title",
              text: "Contact"
            },
            link: {
              class: "indigo-text small-title",
              text: "careers@darklang.com",
              url: "mailto:careers@darklang.com"
            }
          }
        ]
      }
    ]
  },
  {
    ...tryDark,
    class: "white-background"
  }
];

const benefitsPageData = [
  {
    type: "Center",
    class: "short white-background",
    title: { text: "Benefits", class: "large-title medium-purple" },
    paragraph: [
      {
        class: "small-title center-text mankSans",
        text:
          "We find that some people sometimes don't apply to early stage companies because they're known for having \"perks\" instead of benefits. At Dark, we offer benefits to support employees and their families."
      }
    ],
    centerAction: null
  },
  {
    type: "LeftAlignTwoColumn",
    class: "grey-sideline",
    columns: [
      {
        title: {
          class: "medium-purple align-right mankSans",
          text: "Health, Dental, Vision, and Life Insurance"
        },
        paragraph: {
          class: "paragraph-text mankSans",
          text:
            "Dark offers Kaiser Platinum for all employees and dependents, covered at 100%. We also offer 2 Blue Shield PPO options, and the employee only pays the difference from Kaiser. We offer Dental, Vision, and Life insurance coverage through Guardian."
        },
        link: {
          class: "light-purple paragraph-text",
          text: "Read more about why",
          url:
            "https://medium.com/darklang/why-dark-covers-100-of-employee-and-dependent-healthcare-faa0832ef23c",
          external: true
        }
      },
      {
        title: {
          class: "medium-purple align-right mankSans",
          text: "401K"
        },
        paragraph: {
          class: "paragraph-text mankSans",
          text:
            "We offer a 401k plan. We do not currently offer company matching, but plan to as the company grows."
        },
        link: null
      },
      {
        title: {
          class: "medium-purple align-right mankSans",
          text: "Vacation"
        },
        paragraph: {
          class: "paragraph-text mankSans",
          text:
            'We have a flexible vacation policy, and nine specific paid holidays. We encourage employees to take three or more weeks of vacation per year. In addition, once per quarter employees are able to take a "duvet day". A duvet day is for when you just need a day to yourself, no questions asked.'
        },
        link: null
      },
      {
        title: {
          class: "medium-purple align-right mankSans",
          text: "Parental Leave"
        },
        paragraph: {
          class: "paragraph-text mankSans",
          text:
            "We know that families can happen in a lot of different ways, so our policy applies to all full-time employees, regardless of the makeup of their family. There is no minimum employment time requirement to take advantage of this leave. We currently offer up to 4 weeks of fully paid time off, and 4 weeks of part-time employment, during which you can work from home, work partial days at the office, or work a reduced number of days. This can be allocated continuously, or in chunks across the 30 week child-bonding period beginning 3 weeks before the arrival of the child and concluding 27 weeks after."
        },
        link: null
      },
      {
        title: {
          class: "medium-purple align-right mankSans",
          text: "Professional Development"
        },
        paragraph: {
          class: "paragraph-text mankSans",
          text:
            "As is standard, we'll get you whatever you need for your workspace: fully loaded laptop, ergonomic keyboard, standing desk, headphones, etc. We're also supportive of books and local meetup attendance, and will cover the cost. We specifically encourage employees to go to one conference per year of their choice, and cover all conference and travel costs."
        },
        link: null
      }
    ]
  },
  workAtDark,
  tryDark
];

export { careersPageData, benefitsPageData };
